$('.off-canvas__btn').click(function () {
	$('.off-canvas').toggleClass('active');
});



// WEBPACK FOOTER //
// ./_dev/blocks/off-canvas/off-canvas.js